import { createPortal } from 'react-dom';
import { Menu } from 'antd';
import type { MenuProps } from 'antd/es/menu';
import React from 'react';
import styles from './index.module.scss';

export interface MenuAreaRef {
  menuAreaRef: HTMLDivElement | null;
}

interface MenuAreaProps extends MenuProps {
  visible: boolean;
  points: { x: string; y: string };
}

export default React.forwardRef<MenuAreaRef, MenuAreaProps>(
  function MenuArea(props, ref) {
    const {
      visible,
      points: { x, y },
      className,
      ...rest
    } = props;

    const menuAreaRef = useRef<HTMLDivElement>(null);

    useImperativeHandle(ref, () => {
      return {
        menuAreaRef: menuAreaRef.current,
      };
    }, []);

    return (
      <>
        {document.querySelector('body') &&
          createPortal(
            <div
              ref={menuAreaRef}
              className={cls(
                styles.menuAreaWrapper,
                visible && styles.showMenuAreaWrapper
              )}
              style={{ left: x, top: y }}
            >
              <Menu className={cls(styles.menuArea, className)} {...rest} />
            </div>,
            document.querySelector('body')!
          )}
      </>
    );
  }
);
